function getMobileHeaderContainer() {
    return $('#header_mobile');
}

function resetMobileHeaderContainer() {
    getMobileHeaderContainer().css({height: '', overflow: ''});
}

function fitMobileHeaderContainer() {
    var mainHeight = $('.main-container').height() || 0;
    var leftHeight = $('.left-container.open').height() || 0;
    var viewportHeight = $(window).height() || 0;
    var height = Math.max(mainHeight, leftHeight, viewportHeight);

    getMobileHeaderContainer().css({height: height, overflow: 'hidden'});
}

function closeMobileUserMenu() {
    $('.main-container').removeClass('overlay');
    $('.user-menu-popup').hide();
}

function closeMobileSideMenu() {
    $('body').removeClass('body_1');
    $('.left-container').removeClass('open');
    $('.main-container').removeClass('open');
    $('#c-header-mobile__menu').attr('data', 1);
    $('.c-header-mobile__menu-icon').removeClass('mobile__menu__1');
    resetMobileHeaderContainer();
}

function openMobileSideMenu() {
    closeMobileUserMenu();
    $('body').addClass('body_1');
    $('.left-container').addClass('open');
    $('.main-container').addClass('open');
    $('#c-header-mobile__menu').attr('data', 2);
    $('.c-header-mobile__menu-icon').addClass('mobile__menu__1');
    fitMobileHeaderContainer();
}

function toggleMobileSideMenu() {
    if ($('.main-container').hasClass('open')) {
        closeMobileSideMenu();
    } else {
        openMobileSideMenu();
    }
}

function toggleMobileUserMenu() {
    var mainContainer = $('.main-container');

    closeMobileSideMenu();

    if (mainContainer.hasClass('overlay')) {
        closeMobileUserMenu();
        resetMobileHeaderContainer();
    } else {
        mainContainer.addClass('overlay');
        $('.user-menu-popup').show();
        fitMobileHeaderContainer();
    }
}

function hide_menu() {
    toggleMobileSideMenu();
}

function toogle_menu_mb() {
    $('.toogle_cate').click(function() {
        var id = $(this).data('id');
        var category = $('#cate_' + id);

        if (category.hasClass('cate_open')) {
            category.fadeOut(500);
            category.removeClass('cate_open');
            $(this).removeClass('fa-minus').addClass('fa-plus');
        } else {
            category.fadeIn(500);
            category.addClass('cate_open');
            $(this).removeClass('fa-plus').addClass('fa-minus');
        }
    });

    $('.toogle_cc_cate').click(function() {
        var id = $(this).data('id');
        var category = $('#cc_cate_' + id);

        if (category.hasClass('cate_open')) {
            category.fadeOut(500);
            category.removeClass('cate_open');
            $(this).removeClass('fa-minus').addClass('fa-plus');
        } else {
            category.fadeIn(500);
            category.addClass('cate_open');
            $(this).removeClass('fa-plus').addClass('fa-minus');
        }
    });
}

function toogle_menu_page_mb() {
    $('.toogle_cate_page').click(function() {
        var id = $(this).data('id');
        var category = $('#cate_page_' + id);

        if (category.hasClass('cate_open')) {
            category.fadeOut(500);
            category.removeClass('cate_open');
            $(this).removeClass('fa-minus').addClass('fa-plus');
        } else {
            category.fadeIn(500);
            category.addClass('cate_open');
            $(this).removeClass('fa-plus').addClass('fa-minus');
        }
    });

    $('.toogle_cc_cate_page').click(function() {
        var id = $(this).data('id');
        var category = $('#cc_cate_page_' + id);

        if (category.hasClass('cate_open')) {
            category.fadeOut(500);
            category.removeClass('cate_open');
            $(this).removeClass('fa-minus').addClass('fa-plus');
        } else {
            category.fadeIn(500);
            category.addClass('cate_open');
            $(this).removeClass('fa-plus').addClass('fa-minus');
        }
    });
}

function sort_mobile() {
    $('.sort_mobile a').click(function() {
        $('html, body').scrollTop(0);
        $('html').addClass('state-sort');
    });

    $('#sort-menu .list-group-item a').click(function() {
        var type = $(this).data('type');
        var sort = $(this).data('sort');
        var route = $('input[name=route]').val();
        var url = route;

        if (type !== '' && sort !== '') {
            url = route + '?sort[' + type + ']=' + sort;
        }

        window.location.href = url;
    });

    $('.context-back').click(function(event) {
        event.preventDefault();
        $('html').removeClass('state-sort');
    });
}

$(document).ready(function() {
    $('.menu_mobi_click_add').click(function() {
        closeMobileSideMenu();
    });

    $('.main-container').click(function(event) {
        if ($(this).hasClass('open')) {
            closeMobileSideMenu();
        } else if ($(this).hasClass('overlay')) {
            if ($(event.target).closest('.user-menu-popup').length) {
                return;
            }

            closeMobileUserMenu();
            resetMobileHeaderContainer();
        }
    });

    $('#c-header-mobile__menu').click(function(event) {
        event.preventDefault();
        event.stopPropagation();
    });

    $('#c-header-mobile__user-menu').click(function(event) {
        event.preventDefault();
        event.stopPropagation();
        toggleMobileUserMenu();
    });

    toogle_menu_mb();
    toogle_menu_page_mb();
    sort_mobile();
});

$(window).scroll(function() {
    if ($(this).scrollTop() > 30) {
        $('.c-header-mobile').addClass('fixed_mb');
    } else {
        $('.c-header-mobile').removeClass('fixed_mb');
    }
});
